import React, { useState } from 'react';
import { useMenu } from '../hooks/useMenu';

import MenuHeader from '../components/MenuHeader';
import CategoryFilter from '../components/CategoryFilter'; 
import MenuList from '../components/MenuList';
import DishDetailModal from '../components/DishDetailModal';

import Config from "../Config.json";
import ICON from "../assets/icons/favicon.ico";

const TITLE = Config.SITE_TITLE + " - Cardápio";
const DESC = "Conheça o cardápio da Deli da Persy. Lanches, bebidas e sobremesas.";
const CANONICAL = Config.SITE_DOMAIN + "/cardapio";

function MenuPage() {
    const { 
        dishes,
        categories,
        selectedCategory,
        handleSelectCategory,
        isLoading, 
        error 
    } = useMenu();

    const [selectedDish, setSelectedDish] = useState(null);

    // Enhanced Select Category: Rola suavemente para baixo do Header
    const handleCategoryClick = (category) => {
        handleSelectCategory(category);
        // Desce a tela até o topo da lista de pratos
        window.scrollTo({
            top: 300, 
            behavior: 'smooth'
        });
    };

    return (
        <div className="min-h-screen bg-[#FFF5EE] relative">
            <title>{TITLE}</title>
            <link rel="icon" href={ICON} />
            <link rel="canonical" href={CANONICAL} />
            <meta name="description" content={DESC} />

            {/* Background Texture opcional */}
            <div className="absolute top-0 left-0 w-full h-full opacity-[0.03] pointer-events-none bg-[url('https://www.transparenttextures.com/patterns/aged-paper.png')]" />
            
            <div className="relative z-10 flex flex-col w-full pb-20">
                <MenuHeader />
                
                {!isLoading && categories.length > 1 && (
                    <CategoryFilter
                        categories={categories}
                        selectedCategory={selectedCategory}
                        onSelectCategory={handleCategoryClick}
                    />
                )}
                
                <MenuList 
                    dishes={dishes} 
                    isLoading={isLoading} 
                    error={error} 
                    onDishClick={setSelectedDish} 
                />

                {selectedDish && (
                    <DishDetailModal 
                        dish={selectedDish} 
                        onClose={() => setSelectedDish(null)} 
                    />
                )}
            </div>
        </div>
    );
}

export default MenuPage;